/** 登录/注册后的礼券绑定引导（保留原 href 回跳） */

import { isReferralBindReminderSkipped } from '@/utils/referralBindReminder'

export async function resolvePostLoginRoute(defaultPath = '/', options = {}) {
  const href = typeof defaultPath === 'string' && defaultPath.startsWith('/') ? defaultPath : '/'
  if (options.skipReferralForExam || href.startsWith('/exam/')) {
    return href
  }
  return resolveReferralBindRoute(href)
}

export async function resolveReferralBindRoute(defaultPath = '/') {
  const href = typeof defaultPath === 'string' && defaultPath.startsWith('/') ? defaultPath : '/'
  if (isReferralBindReminderSkipped()) {
    return href
  }
  try {
    const token = localStorage.getItem('jwt_token')
    if (!token) return href
    const { fetchReferralBindStatus } = await import('@/utils/referralCoupon')
    const st = await fetchReferralBindStatus()
    if (!st.hasBinding && st.canBind) {
      return {
        path: '/referral/bind-coupon',
        query: href && href !== '/' ? { href } : undefined
      }
    }
  } catch {
    // ignore
  }
  return href
}
